import styled from 'styled-components';
import GroverLogo from 'ggApp/shared/icons/GroverLogo';

const Wrap = styled.div`
    display: flex;
    justify-content: center;
`;

const Logo = styled(GroverLogo)`
    height: 60px;
    max-width: 140px;
    width: auto;
    margin: 0 auto;
    ${props => props.theme.superQuery.all.and.maxWidth.mobileMax.css`
        height: 30px;
    `}
`;

const Link = styled.a`
    color: rgba(255, 255, 255, 0.1);
    text-decoration: none;

    &:hover {
        color: rgba(255, 255, 255, 0.1);
        text-decoration: none;
    }

    &:visited {
        color: rgba(255, 255, 255, 0.1);
        text-decoration: none;
    }
`;

export { Logo, Wrap, Link };
